module.exports = __webpack_public_path__ + "img/cscs.34d9394.svg";